import { GAME_HAND_PHASE } from 'constants/gameConstants';

type LivePovCardObservation = {
  showCards: boolean | undefined;
  hasActiveHandPhase: boolean;
  handNum: number;
  isWaitingForHand: boolean;
};

/**
 * True when the current render is a genuine observation of the local player's
 * cards *during live play* — the cards are visible, we're inside an active
 * hand's deal/betting phases (>= PRE_FLOP and before the end-of-hand collect
 * phase), and the player isn't merely waiting to be dealt in.
 *
 * The upper bound (< RECORD_NEW_STATS_AND_START_NEW_HAND) is the important part:
 * a client that joins or reconnects during showdown first sees the POV cards at
 * the collect phase. Without the bound it would be counted as "seen", which
 * flips hasSeenPovCardsRef true and lets the end-of-hand collect animation run
 * from a cold mount — rendering the player's own cards askew and stuck showing
 * the card back (see EN-10309). A client only earns the collect animation if it
 * actually watched the cards in play first.
 */
export const isLivePovCardObservation = ({
  showCards,
  hasActiveHandPhase,
  handNum,
  isWaitingForHand
}: LivePovCardObservation) =>
  !!showCards &&
  hasActiveHandPhase &&
  handNum >= GAME_HAND_PHASE.PRE_FLOP_BETTING_ROUND &&
  handNum < GAME_HAND_PHASE.RECORD_NEW_STATS_AND_START_NEW_HAND &&
  !isWaitingForHand;
